module.exports = __webpack_public_path__ + "static/media/PRESTADORES_Mesadetrabajo1.b26a0ef5.png";